import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Step from "@mui/material/Step";
import StepConnector from "@mui/material/StepConnector";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";

import {
  getTerminalProgressStep,
  getVisibleProgressSteps,
  PROGRESS_STEP_LABEL_SX,
} from "./terminalProgressStep";

// Custom arrow connector
function ArrowConnector() {
  return (
    <StepConnector
      sx={{
        flex: "0 0 auto",
        width: 13,
        padding: 0,
        margin: 0,
        position: "relative",

        "& .MuiStepConnector-line": {
          display: "none",
        },

        "&.MuiStepConnector-root": {
          top: -12, // 👈 aligns with icon center
        },

        "&::after": {
          content: '">"',
          fontSize: "1rem",
          color: "text.secondary",
          fontWeight: 700,
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        },
      }}
    />
  );
}

interface ProgressStepperProps {
  allSteps: string[];
  progressValue: number;
  shipmentStatus: ShipmentStatusValue | undefined;
}

/*
  Shared render body for every shipment progress stepper. Each stepper owns its
  own step math (the STEPS constant and progressValue) and delegates the render
  here so all steppers share identical styling and terminal-state handling.
*/
export function ProgressStepper(props: ProgressStepperProps) {
  const { allSteps, progressValue, shipmentStatus } = props;
  const { steps, activeStep } = getVisibleProgressSteps(
    allSteps,
    progressValue,
    shipmentStatus,
  );

  return (
    <Box>
      <Stepper
        activeStep={activeStep}
        connector={<ArrowConnector />}
        sx={{ justifyContent: "center" }}
      >
        {steps.map((label, index) => (
          <Step completed={progressValue >= index} key={label}>
            <StepLabel sx={PROGRESS_STEP_LABEL_SX}>
              <Typography variant="caption">{label}</Typography>
            </StepLabel>
          </Step>
        ))}
        {getTerminalProgressStep(shipmentStatus)}
      </Stepper>
    </Box>
  );
}
